import { render } from "./RegistroTarifa.vue?vue&type=template&id=40b3cbce&scoped=true"
import script from "./RegistroTarifa.vue?vue&type=script&lang=js"
export * from "./RegistroTarifa.vue?vue&type=script&lang=js"

import "./RegistroTarifa.vue?vue&type=style&index=0&id=40b3cbce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40b3cbce"]])

export default __exports__